import { getProposals as getProposalsApi } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type { GetProposalsServiceRequest, GetProposalsServiceResponse } from './get-proposals.dto';
import {
  GetProposalsServiceRequestSchema,
  GetProposalsServiceResponseSchema,
} from './get-proposals.dto';

export const getProposalsService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(GetProposalsServiceRequestSchema),
    async (request: GetProposalsServiceRequest): Promise<GetProposalsServiceResponse> => {
      const apiResponse = await getProposalsApi(request);

      if (apiResponse.meta?.result === 'FAIL') {
        throw new Error(apiResponse.meta?.message ?? '캠페인 제안 목록 조회에 실패했습니다.');
      }

      const hasNextPage = apiResponse.link?.next !== null && apiResponse.link?.next !== undefined;
      const nextPage = hasNextPage ? request.page + 1 : undefined;

      return {
        list: apiResponse.data.list,
        total: apiResponse.link?.total ?? 0,
        pagination: {
          currentPage: request.page,
          pageSize: request.size,
          hasNextPage,
          nextPage,
        },
      };
    },
    validateServiceResponse(GetProposalsServiceResponseSchema),
  ),
);
